<template>
    <div class="JobsList divide-y divide-gray-400 dark:divide-default">
        <template v-for="(job, index) in jobs" :key="index">
            <CAchievementBox
                class="py-5"
                :class="{
                    'pt-0': index === 0,
                    'pb-0': index === jobs.length - 1
                }"
            >
                <template #icon>
                    <CIcon name="work" />
                </template>

                <template #title>
                    {{ currentJob(job) }}
                </template>

                <template v-if="job.startYear" #year>
                    {{ job.startYear }} -
                    {{ job.endYear || 'súčasnosť' }}
                </template>

                <template v-if="!isAnonymous" #subtitle>
                    {{ job.address }}
                </template>

                <template v-if="!isAnonymous && job.desc" #description>
                    <span v-html="job.desc" />
                </template>
            </CAchievementBox>
        </template>
    </div>
</template>

<script setup lang="ts">
import { JobPosition } from '#shared/types/User'
import CAchievementBox from '@/components/ui/CAchievementBox.vue'
import CIcon from '@/components/ui/CIcon.vue'

const props = defineProps({
    jobs: {
        type: Array as () => JobPosition[],
        required: true
    },
    isAnonymous: {
        type: Boolean,
        default: false
    }
})

function currentJob(currentJob: JobPosition): string {
    return props.isAnonymous
        ? currentJob?.position ?? ''
        : [currentJob?.position, currentJob?.org].filter(Boolean).join(' @ ')
}
</script>x